import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import RreoList from '../../components/lrf/listar/rreo';


function RreoScreen () {
    return (
        <Fragment>
            <Head titulo="Relatório Resumido da Execução Orçamentária - RREO"/>
            <Header />
            <Container>
                <RreoList />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default RreoScreen;